export default {
    apiKey: "AIzaSyB_UyKVpJH1EZyZxrZ0fMk4870ZUWOjycg",
    authDomain: "ormoc-ctzn-monitoring.firebaseapp.com",
    databaseURL: "https://safeormoc.firebaseio.com",
    projectId: "safeormoc",
    storageBucket: "safeormoc.appspot.com",
    messagingSenderId: "476536898361",
    appId: "1:476536898361:web:ef448d41b8338902a9dee8",
    measurementId: "G-DZ0MFLTRSQ"
};
